import { createSelector } from 'reselect';

const EXTENDED_ITEM_TYPE = 'items';

const createCategoryResults = (results, data, categoryName, map) => {

    if(!data || data.length <= 0) {
        return results;
    }

    let topFive = data.slice(0,5).map(map);

    if(data.length > 5) {
        const moreItems = [{
            id: `MORE_${categoryName}_ITEM`,
            title: `${data.length - 5} more...`,
            extended : {
                type: EXTENDED_ITEM_TYPE,
                key: 'more'
            },
        }];

        topFive = [...topFive, ...moreItems];
    }

    results[categoryName] = {
        'name': categoryName,
        'results': topFive,
    };

    return results;
};

const formatQuickSearchResults = createSelector(
    state => state,
    (state) => {

        let returnResults = {};

        let items = state.search.results.items ? state.search.results.items.items : [];

        createCategoryResults(returnResults, items, 'Items',
            r => {
                return {
                    id: r._id,
                    title: r.Name.English,
                    image: `\\images\\${r.Icon}.png`,
                    extended: {
                        type: EXTENDED_ITEM_TYPE,
                        key: r.ItemKey,
                    }
                }
            }
        );

        createCategoryResults(returnResults, state.search.results.npcs, 'NPCs',
            r => { return { id: r._id, title: r.PrimaryName.English, description: r.SecondaryName ? r.SecondaryName.English : '' } });

        createCategoryResults(returnResults, state.search.results.achievements, 'Achievements',
            r => { return { id: r._id, title: r.Name.English, description: r.Description ? r.Description.English : r.Description } });

        createCategoryResults(returnResults, state.search.results.quests, 'Quests',
            r => { return { id: r._id, title: r.Name.English, description: r.ShortDescription ? r.ShortDescription.English : '' } });

        return returnResults;
    }
);

export default formatQuickSearchResults;


// WEBPACK FOOTER //
// ./src/search/selectors/quickSearchSelector.js